/** Autosave of the working document, so a reload never loses work. */

const KEY = 'latex-preview.document';
const SAVE_DELAY_MS = 400;

export function loadDocument(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null; // Storage can be unavailable (private mode, blocked cookies).
  }
}

let timer: number | undefined;

export function scheduleSave(text: string): void {
  window.clearTimeout(timer);
  timer = window.setTimeout(() => {
    try {
      window.localStorage.setItem(KEY, text);
    } catch {
      // Best-effort: quota or availability problems just skip the save.
    }
  }, SAVE_DELAY_MS);
}

export function clearSaved(): void {
  window.clearTimeout(timer);
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Ignore, same as above.
  }
}
